'use client';

import { useRef } from 'react';

/** Returns a ref that always holds the latest value, useful for avoiding stale closures in callbacks. */
export function useLatestRef<T>(value: T): React.RefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
